import React from 'react';
import BaseToast, { TypeEnum } from '@src/business-components/common-message/base-toast';
import DownLoadStore from './store';
import wrapStore from '@src/utils/wrap-store';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import redirect from '@src/utils/redirect-if-mobile-accress';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const lang = getLanguageByPath();
const pageLocalesData = getPageLocalesData();
// 移动端页面，如果是PC端访问，跳转到PC端页面
//redirect.redirectIfPc();

const DownLoad = ({ store }) => {
  // //console.log(' NewsDetail   store:', store);
  let text = 'Please copy the link and paste it into your PC browser to open.';
  if (lang === 'zh-Hant' || lang === 'tc') {
    text = '請在電腦端訪問此頁面';
  }

  store.use();
  return (
    <div
      style={{
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        width: '100vw',
        height: '100vh',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <BaseToast type={TypeEnum.INFO} text={text} />
    </div>
  );
};

export default wrapStore(DownLoad, DownLoadStore);
